import React from 'react';
import { useTranslation } from 'react-i18next';

import LoadThemeComponent from '../../../base/LoadThemeComponent';
import { IS_CASINO_ENABLED } from '../../../crm/helpers/Constants';
import { isPremierDubai } from '../../../utils/template';
import HeaderMenu from '../../default/HeaderMenu';

function DropdownMenu({ links, user, onClose }) {
    const { t } = useTranslation();
    const notificationsEnabled = (process.env.MIX_NOTIFICATIONS_ENABLED?.toLowerCase() === 'true');

    const handleCloseDropdown = () => {
        onClose();
    };

    const nameMap = {
        overview: t('userPanel.myAccount'),
        tickets: t('userPanel.tickets'),
        bonuses: t('userPanel.bonuses'),
        transactions: t('userPanel.transactions'),
        deposit: t('userPanel.deposit'),
        resellerCustomers: t('userPanel.mySalesAccount'),
        logout: t('userPanel.logout'),
    };

    const customOrder = ['overview', 'tickets', 'bonuses', 'transactions', 'deposit', 'resellerCustomers', 'logout'];

    const menuItems = customOrder
        .map((key, index) => {
            if (!links[key]) return null;
            if (key === 'bonuses' && !IS_CASINO_ENABLED) return null;
            if (key === 'resellerCustomers' && (!notificationsEnabled || !user.isReseller)) return null;

            return {
                name: nameMap[key],
                url: links[key],
                order: index + 1,
            };
        })
        .filter(Boolean);

    const baseView = () => (
        <div className="dropdown-menu menu-account">
            <div className="dropdown-item-wrapper">
                <a className="dropdown-item" href={links.overview}>
                    {t('userPanel.myAccount')}
                </a>
                <a className="dropdown-item" href={links.tickets}>
                    {t('userPanel.tickets')}
                </a>
                {IS_CASINO_ENABLED && (
                    <a className="dropdown-item" href={links.bonuses}>
                        {t('userPanel.bonuses')}
                    </a>
                )}
                <a className="dropdown-item" href={links.transactions}>
                    {t('userPanel.transactions')}
                </a>
                <a className="dropdown-item" href={links.deposit}>
                    {isPremierDubai() ? t('myTransactions.contributions') : t('userPanel.deposit')}
                </a>
                {notificationsEnabled && user.isReseller && (
                    <a className="dropdown-item" href={links.resellerCustomers}>
                        {t('userPanel.mySalesAccount')}
                    </a>
                )}
                <a className="dropdown-item" href={links.logout}>
                    {t('userPanel.logout')}
                </a>
            </div>
        </div>
    );

    const defaultView = () => <HeaderMenu menuItems={menuItems} isGuest={false} onClose={handleCloseDropdown} />;

    return <LoadThemeComponent defaultView={defaultView} baseView={baseView} />;
}

export default DropdownMenu;
